import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from 'app/store';
import createHistory from '@guestyci/history/createHistory';
import LocalizationProvider from '@guestyci/localize/LocalizationProvider';
import { Router } from 'react-router-dom';
import '@guestyci/foundation/style/styles.css';
import App from './app/App';
import bootstrap from './bootstrap';

const history = createHistory({ baseUrl: process.env.PUBLIC_URL });

// Required by Guesty's infrastructure
// DO NOT REMOVE!!!
bootstrap();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router history={history}>
        <LocalizationProvider>
          <App />
        </LocalizationProvider>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
